<script setup>
import { computed, ref } from 'vue';
import { useSenderStore } from '@/stores';
import { useQuasar } from 'quasar';
import { InputSelect } from '@/components/inputs';
import Tr from '@/i18n/translation';
import { ImageType } from 'interface/data/image/type';

const props = defineProps({
  clientId: {
    type: String,
    required: true,
  },
});

const senderStore = useSenderStore();
const quasar = useQuasar();

const langList = ['', ...Tr.supportedLocales];

const files = ref(null);
const sending = ref(false);
const purpose = ref(ImageType.EVENTPICTURE);
const imgId = ref('0');
const lang = ref('');

const btnText = computed(() => {
  if (sending.value) {
    return 'WYSYŁANIE';
  }

  return 'PRZEŚLIJ';
});

function onRejected(_rejectedEntries) {
  quasar.notify({
    type: 'negative',
    message: `Możesz przesłać maksymalnie 1 zdjęcie w formacie webp`,
  });
}

async function sendPicture() {
  if (props.clientId && files.value) {
    files.value.forEach((file) => {
      senderStore.addImage(file, purpose.value, [
        { id: imgId.value },
        { lang: lang.value },
      ]);
    });
    files.value = null;
    const res = await senderStore.sendImages(
      'createSenderStream',
      'sendClientImage',
      props.clientId,
    );

    if (res) {
      quasar.notify({
        type: 'info',
        message: `Rozpoczęto wysyłanie plików. Dziękujemy :)`,
      });
    } else {
      quasar.notify({
        type: 'negative',
        message: `Błąd w przesyle plików`,
      });
    }
  } else {
    quasar.notify({
      type: 'negative',
      message: `Nie wybrano plików/brak id klienta`,
    });
  }
}
</script>

<template>
  <q-form ref="ImageForm" class="form" @submit.prevent="sendPicture">
    <div class="send">
      <button
        class="core-default-form-button"
        :disabled="sending"
        type="submit"
      >
        {{ btnText }}
      </button>
    </div>
    <q-file
      v-model="files"
      outlined
      label="Dodaj plik webp lub gif"
      multiple
      max-total-size="1073741824"
      max-files="1"
      accept=".webp, .gif"
      class="input-file"
      @rejected="onRejected"
    />
    <div class="input">
      <p class="label">Purpose</p>
      <q-select
        v-model="purpose"
        class="core-default-input-form select-form"
        keep-color
        dense
        :options="Object.values(ImageType)"
        color="primary"
      />
    </div>
    <div
      v-show="purpose === 'additionalSites' || purpose === 'rsvpWishes'"
      class="input"
    >
      <p class="label">Id grafiki</p>
      <q-input
        v-model="imgId"
        class="core-default-input-form"
        borderless
        autogrow
        lazy-rules
        :rules="[(val) => !!val || 'To pole nie może być puste']"
      />
    </div>
    <InputSelect
      v-model="lang"
      class="input"
      :select-options="langList"
      main-color="#84491f"
      background-color="#fffbf8"
      text-font="Raleway"
      >Język</InputSelect
    >
  </q-form>
</template>

<style lang="scss" scoped>
@import './form';
</style>
